import { EPromotionSearchMethod } from 'core/model/enums';
import type { IPromotionParams } from 'core/model/interfaces/promotions';
import type { TSliceReducer } from 'core/store';
import type { IPromotionsState } from './types';

const updatePromotionsPage: TSliceReducer<IPromotionsState, number | undefined> = (state, { payload }) => {
  state.promotionList.pagination.currentPage = payload ?? 1;
};

const changeSearchMethod: TSliceReducer<IPromotionsState, EPromotionSearchMethod> = (state, { payload }) => {
  state.searchMethod = payload;
};

const updatePromotionFilters: TSliceReducer<IPromotionsState, IPromotionParams> = (state, { payload }) => {
  state.filters = { ...state.filters, ...payload };
};

const clearPromotionFilters: TSliceReducer<IPromotionsState> = state => {
  state.filters = {};
};

export const reducers = { updatePromotionsPage, changeSearchMethod, updatePromotionFilters, clearPromotionFilters };
